import { TransactionRule } from '@types'

export const mapChangeCriteria = <T>(
  criteria: TransactionRule<T>['data']['criteria'],
) => {
  return criteria
    .map(item =>
      [
        item.type,
        item.params
          .map(param => [param.comparison, param.value].join(' '))
          .join(` ${item.logic} `),
      ].join(' '),
    )
    .join(' AND ')
}
